<template>
  <div class="ask-actions" :class="`ask-actions-${surface}`">
    <div v-if="entryActions.length" class="ask-actions-row">
      <button
        v-for="entry in entryActions"
        :key="entry.key"
        type="button"
        class="ask-action"
        :data-ask-navigate="entry.navigate ? '1' : undefined"
        @click="run(entry)"
      >
        <span>{{ entry.label }}</span><ArrowUpRightIcon />
      </button>
    </div>
    <div v-if="labVisible" class="ask-actions-lab" data-ask-actions-lab>
      <p class="ask-actions-lab-kicker">Try the live comparison</p>
      <RetrievalLab />
    </div>
  </div>
</template>

<script>
import ArrowUpRightIcon from './ArrowUpRightIcon.vue';
import RetrievalLab from '../view/RetrievalLab.vue';

const ACTION_COPY = {
  search: 'Search the site',
  ask: 'Ask a question',
  view: 'Compose a View',
  views: 'Explore public Views',
};

export default {
  name: 'AskActions',
  components: { ArrowUpRightIcon, RetrievalLab },
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    surface: {
      type: String,
      default: 'home',
    },
  },
  computed: {
    entryActions() {
      return (this.actions || [])
        .filter((entry) => entry.type !== 'component')
        .map((entry, index) => ({
          ...entry,
          key: `${entry.type}-${entry.action || entry.path || entry.id || index}`,
          label: entry.type === 'action' ? ACTION_COPY[entry.action] : entry.label,
          navigate: entry.type === 'link' || (entry.type === 'action' && entry.action === 'views'),
        }))
        .filter((entry) => entry.label);
    },
    labVisible() {
      return (this.actions || []).some((entry) => entry.type === 'component' && entry.id === 'retrieval-lab');
    },
  },
  methods: {
    run(entry) {
      if (entry.type === 'action') {
        const eventName = {
          search: 'open-site-search',
          ask: 'open-site-ask',
          view: 'open-site-view',
        }[entry.action];
        if (eventName) window.dispatchEvent(new CustomEvent(eventName));
        else if (entry.action === 'views') this.$router.push('/views').catch(() => {});
        return;
      }
      if (entry.type === 'link' && entry.path) {
        this.$router.push(entry.path).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.ask-actions {
  margin-top: 0.85rem;
}

.ask-actions-palette {
  margin-top: 0;
  padding: 0 18px 14px;
}

.ask-actions-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.42rem;
}

.ask-action {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.5rem 0.62rem;
  border: 0;
  border-radius: 0;
  background: rgba(var(--site-accent-rgb), 0.13);
  color: #343434;
  font: 600 0.76rem/1 "Quattrocento Sans", sans-serif;
  cursor: pointer;
  transition: background-color 160ms ease, transform 100ms ease-out;
}

.ask-action .site-arrow-up-right {
  color: var(--site-accent);
  transition: transform 160ms ease;
}

.ask-action:hover,
.ask-action:focus-visible {
  background: rgba(var(--site-accent-rgb), 0.22);
}

.ask-action:hover .site-arrow-up-right,
.ask-action:focus-visible .site-arrow-up-right {
  transform: translate(2px, -2px);
}

.ask-action:focus-visible {
  outline: 1px solid currentColor;
  outline-offset: 3px;
}

.ask-action:active {
  transform: scale(0.98);
}

.ask-actions-lab {
  margin-top: 0.85rem;
}

.ask-actions-lab-kicker {
  margin: 0 0 0.5rem;
  color: var(--site-accent);
  font: 600 0.67rem/1.2 "Quattrocento Sans", sans-serif;
  letter-spacing: 0.055em;
  text-transform: uppercase;
}

body.dark-mode .ask-action {
  background: rgba(var(--site-accent-rgb), 0.15);
  color: #e2e2e2;
}

body.dark-mode .ask-action:hover,
body.dark-mode .ask-action:focus-visible {
  background: rgba(var(--site-accent-rgb), 0.24);
}

body.dark-mode .ask-action .site-arrow-up-right,
body.dark-mode .ask-actions-lab-kicker {
  color: var(--site-accent);
}

@media (prefers-reduced-motion: reduce) {
  .ask-action,
  .ask-action .site-arrow-up-right {
    transition-duration: 0.01ms;
  }
}
</style>
